import type { Perfil } from '@pcp/contracts';

/** Espelham a matriz de `docs/09` (o BFF é a barreira de verdade; aqui só decidimos o que mostrar). */
export const PERFIS_ESCRITA: readonly Perfil[] = ['admin', 'importacao'];
export const PERFIS_FINANCEIRO: readonly Perfil[] = ['admin', 'importacao', 'financeiro'];
export const PERFIS_IMPORTACAO: readonly Perfil[] = ['admin', 'planner', 'viewer', 'importacao', 'financeiro'];
